import "./Game.scss";
import MobileNavigation from "../components/MobileNavigation/MobileNavigation";
import { useEffect, useState } from "react";
import { isMobile } from 'react-device-detect';

const DEFAULT_EXAMPLE_URL =
  "https://magictown-frontend-stage-demominor.llgmf.com/?login_id=9nM58BYQ2PhA8UUl%2BqEgAqwk0BAe%2FVfQucI3kESwV%2FmYocoMPb%2Fy62MZTN2hBffIpcyxX30WFTE5%2FXnehz3%2BBQ&lang=EN&currency=EUR&country=UA&location=LocationBase";

function Game() {
  // const [gameAuthUrl] = useState(DEFAULT_EXAMPLE_URL);
  const [gameAuthUrl, setGameAuthUrl] = useState(null);
  // window.scrollTo(0, 0);
  useEffect(() => {

    fetch(
      "https://magictown-gw1-stage-demoguest.llgmf.com/partner-api/v2/map-builder/exec-guest",
      {
        method: "POST",
        // body: JSON.stringify({ username: "example" }),
        // …
      },
    )
      .then((result) => {
        try {
          result.json().then((response) => {
            const urlData = response.data.execUrl;
            console.log("Using auth url from SERVER :", urlData);
            setGameAuthUrl(urlData);
          });
        } catch (error) {
          throw new Error("Invalid response data");
        }
      })
      .catch((error) => {
        console.error("Error fetching game auth URL:", error);
        console.log("Using DEFAULT URL:", DEFAULT_EXAMPLE_URL);
        setGameAuthUrl(DEFAULT_EXAMPLE_URL);
      });
  }, []);

  return (
    <div className='app-root-content'>
      <div className='game-wrapper'>
        {!gameAuthUrl && <div className='loading-message'>Loading...</div>}
        {gameAuthUrl && (
          <iframe
            src={gameAuthUrl}
            title='Game'
            width='100%'
            height='100%'
            style={{ border: "none", flex: 1 }}
          />
        )}
      </div>
      { isMobile && <div className='menu-space'></div> }
      <MobileNavigation />
    </div>
  );
}

export default Game;
